import { removeFromQueueQueryFn } from "./queueQueries";
import { API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { toast } from "react-toastify";
import {
  addToActivityQueueQueryFn,
  getActiveActivityQueueSpotsByMemberQueryFn,
} from "./activityQueueQueries";

export const addToActivityQueue = async (
  member_id: string,
  activity_datetime_start: string,
  datetime_to_place_in_queue: string,
  activity_id: string
) => {
  const { query, inputs, variables } = addToActivityQueueQueryFn(
    member_id,
    activity_datetime_start,
    datetime_to_place_in_queue,
    activity_id
  );
  const myQuery = `
        mutation AddToQueueActivity(${inputs}) {
            ${query}
        }
    `;
  try {
    const getAddToQueueResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;
    const response = getAddToQueueResponse.data.AddToQueueActivity;
    if ("message" in response) {
      toast.error(response.message);
      throw new Error(response.message);
    }
    return response;
  } catch (error: any) {
    toast.error(error);
    return false;
  }
};

export const getActiveActivityQueueSpotsByMember = async (
  member_id: string
) => {
  const { query, inputs, variables } =
    getActiveActivityQueueSpotsByMemberQueryFn(member_id);
  const myQuery = `
        query GetActiveActivityQueueSpotsByMember(${inputs}) {
            ${query}
        }
    `;
  try {
    const getActiveQueueSpotsByMemberResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;
    const response =
      getActiveQueueSpotsByMemberResponse.data
        .getActiveActivityQueueSpotsByMember;
    if ("message" in response) {
      toast.error(response.message);
      throw new Error(response.message);
    }
    return response;
  } catch (error: any) {
    toast.error(error.errors[0].message);
    return false;
  }
};
